<template>
  <generic-modal :title="$t('renap verification')" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('profile')"
              :placeholder="$t('profile')"
              url="/renap/profile/catalog"
              name_field="name"
              value_field="profile_id"
              @selected="set_profile"
              ref="profile_dropdown"
              :is_multiple="false"
            />
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("dpi") }}</label>
            <div class="control">
              <input type="text" class="input" v-model="meta.dpi" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <div class="control">
              <generic-uploader
                ref="generic_uploader"
                :idle_label="$t('drop customer photo here')"
                endpoint_url="/renap/verification/upload"
                :allow_multiple="false"
                @error="error_uploading"
                @success="success_uploading"
              />
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-check"></i>
        </span>
        <span>{{ $t("create") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import { put, post, generate_error_message_text, get } from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";

export default {
  name: "RenapRequestModal",
  components: {
    GenericModal,
    GenericDropdown,
    GenericUploader,
  },
  props: {},
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.profile_id || !v.meta.dpi || !v.meta.photo;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let data = { ...v.meta };
      put("/renap/verification", data)
        .then(() => {
          // console.log("request created");
          v.$emit("success");
          v.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        dpi: "",
        profile_id: "",
        photo: null,
      };
      v.error = "";
      v.$refs.profile_dropdown.clear();
    },
    set_profile(profile) {
      if (profile) {
        let v = this;
        v.meta.profile_id = profile.profile_id;
      }
    },
    error_uploading(error) {
      console.error(error);
      // let v = this;
      // v.error = generate_error_message_text(error);
    },
    success_uploading(response) {
      let v = this;
      // v.$refs.generic_uploader.clear();
      let rspnse = JSON.parse(response.serverId);
      let data = {
        final_name: rspnse.final_name,
        filepath: rspnse.filepath,
      };
      v.meta.photo = data;
    },
  },
  mounted() {},
  created() {},
  watch: {},
};
</script>
<style></style>
